import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button, ButtonGroup, Text,
    Icon, IconButton, Stack, HStack, Image, Wrap, WrapItem, Center,
    Grid, GridItem, VStack, Spacer, Divider, Select,
    Table, Thead, Tbody, Tfoot, Tr, Th, Td, TableCaption, TableContainer, useDisclosure,
} from '@chakra-ui/react';
import ReactPaginate from 'react-paginate';
import {  MdAddCircleOutline, MdEdit, MdDeleteForever, MdNoteAlt, MdFileOpen, MdDownload, MdHistory } from 'react-icons/md';
import { BsArrowLeftCircle, BsArrowRightCircle } from 'react-icons/bs';
import { FormattedDate, FormattedTime } from 'react-intl';

import AddEditPatientResultModal from '../../Modals/AddEditPatientResultModal';
import PatientResultsHistoryModal from '../../Modals/PatientResultsHistoryModal';
import { displayConfirmChoiceAlert } from '../../../utils';

export default function PatientList ({ 
    items, itemsPerPage, itemOffset, pageCount, isAction, t, patientDetail, addEditPatientModal, 
    apiLoadListPatient, apiLoadAPatient, apiDeleteAPatient
}) {
    const [ cookies ] = useCookies(["loginCookie"]);
    const initialRef = useRef(null);
    const patientResultsHistoryModal = useDisclosure();
    const addEditPatientResultModal = useDisclosure();

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage);
        apiLoadListPatient({ company_id: cookies?.loginCookie?.data?.company_id, limit: itemsPerPage, offset: newOffset });
    } 

    return (
        <>
            <TableContainer width="100%" px="20px" py="5px">
                <Table variant="simple" size="sm">
                    <Thead>
                        <Tr bg="#EAF0F0">
                            <Th>{t("Index")}</Th>
                            <Th>{t("Name")}</Th>
                            <Th>{t("Year_Of_Birth")}</Th>
                            <Th>{t("Gender")}</Th>
                            <Th>{t("Passport")}</Th>
                            <Th>{t("Phone")}</Th>
                            <Th>{t("Medical_Card")}</Th>
                            <Th>{t("Address")}</Th>
                            <Th>{t("View_Patient_History")}</Th>
                            <Th>{t("Created_At")}</Th>
                            <Th>{t("Edited_At")}</Th>
                            <Th isNumeric></Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {
                            items && items.map((item, idx) => {
                                return (
                                    <Tr key={item.id}>
                                        <Td>
                                            <Text fontWeight="600">{(itemOffset + idx) + 1}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.name}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{ item.yearOfBirth }</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{ item.gender }</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.passport}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.phone}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.social_insurance}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.address}</Text>
                                        </Td>
                                        <Td>
                                            <VStack alignItems="flex-start">
                                                <Button colorScheme='gray' size="sm" mr={3} isDisabled={!isAction}
                                                    onClick={
                                                        () => {
                                                            apiLoadAPatient({ id: item.id });
                                                            patientResultsHistoryModal.onOpen();
                                                        }
                                                    }
                                                >
                                                    <Icon boxSize={4} as={MdHistory} marginRight="8px"/> 
                                                    <Text fontSize="14px">
                                                        {t("View_Patient_History")}
                                                    </Text>
                                                </Button>

                                                <Button colorScheme='blue' size="sm" mr={3} isDisabled={!isAction}
                                                    onClick={
                                                        () => {
                                                            apiLoadAPatient({ id: item.id });
                                                            addEditPatientResultModal.onOpen();
                                                        }
                                                    }
                                                >
                                                    <Icon boxSize={4} as={MdNoteAlt} marginRight="8px"/> 
                                                    <Text fontSize="14px">
                                                        {t("Type_Patient_Result")}
                                                    </Text>
                                                </Button>
                                            </VStack>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">
                                                <FormattedDate value={item.created_at} />
                                            </Text>
                                        </Td>
                                        <Td>
                                            {
                                                item.updated_at &&
                                                <Text fontWeight="600">
                                                    <FormattedDate value={item.updated_at} /> <FormattedTime value={item.updated_at} />
                                                </Text>
                                            }
                                        </Td>
                                        <Td isNumeric>
                                            <Flex direction="row" justifyContent="flex-end" alignContent="center" gap={1}>
                                                <IconButton
                                                    colorScheme='blackAlpha'
                                                    title='Sửa'
                                                    icon={<MdEdit />}
                                                    isDisabled={!isAction}
                                                    onClick={() => {
                                                            addEditPatientModal.onOpen();
                                                            apiLoadAPatient({ id: item.id });
                                                        }
                                                    }
                                                />
                                                <IconButton
                                                    colorScheme='red'
                                                    title='Xoá'
                                                    icon={<MdDeleteForever />}
                                                    isDisabled={!isAction}
                                                    onClick={() => {
                                                            displayConfirmChoiceAlert('Bạn có muốn xoá bệnh nhân này không?', () => {
                                                                apiDeleteAPatient({ 
                                                                    id: item.id, 
                                                                    payload: { 
                                                                        company_id: cookies?.loginCookie?.data?.company_id,  
                                                                        user_id: cookies?.loginCookie?.data?.id,  
                                                                        is_active: false 
                                                                    } 
                                                                });
                                                            })
                                                        }
                                                    }
                                                />
                                            </Flex>
                                        </Td>
                                    </Tr>
                                )
                            })
                        }
                    </Tbody>
                </Table>
            </TableContainer>

            {/* <Flex w="100%" justify="center" my="10px" position={{base: "relative", md: "fixed", lg: "fixed"}} bottom="0px"> */}
                <ReactPaginate 
                    breakLabel="..."
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={2}
                    pageCount={pageCount}
                    previousLabel={
                        <Center>
                            <Icon boxSize={8} as={BsArrowLeftCircle} />
                        </Center>
                    }
                    nextLabel={
                        <Center>
                            <Icon boxSize={8} as={BsArrowRightCircle} />
                        </Center>
                    }
                    renderOnZeroPageCount={null}
                    containerClassName='pagination'
                    pageClassName='page-item'
                    activeClassName='active'
                    previousClassName='previous-item'
                    nextClassName='next-item'
                />
            {/* </Flex> */}
            {
                patientResultsHistoryModal.isOpen &&
                <PatientResultsHistoryModal 
                    initialRef={initialRef} isOpen={patientResultsHistoryModal.isOpen} onClose={patientResultsHistoryModal.onClose}
                    patientDetail={patientDetail} isAction={isAction}
                />
            }
            {
                addEditPatientResultModal.isOpen &&
                <AddEditPatientResultModal 
                    initialRef={initialRef} isOpen={addEditPatientResultModal.isOpen} onClose={addEditPatientResultModal.onClose} 
                    patientDetail={patientDetail} 
                />
            }
        </>
    )
}